export default "__VITE_ASSET__544d0b8d__"